/* The Sheckii Mini: a small crossword. Works with a keyboard, a phone keyboard and a screen reader. Progress is kept in this browser. */
(function () {
  'use strict';
  var app = document.querySelector('[data-mini-app]');
  if (!app) return;
  var root = app.closest('[data-mini]');
  var entries = [];
  try { entries = JSON.parse(root.querySelector('[data-mini-entries]').textContent); } catch (e) { return; }
  if (!entries.length) return;

  var KEY = 'tp-mini-v1:' + entries.map(function (e) { return e.answer; }).join('');
  var $ = function (s) { return app.querySelector(s); };
  var gridEl = $('[data-mini-grid]'), input = $('[data-mini-input]');

  /* ---- build the model ---- */
  var cells = {}; // "r,c" -> { r, c, answer, num, el, words: {A: i, D: i} }
  var maxR = 0, maxC = 0;
  entries.forEach(function (e, i) {
    e.answer = String(e.answer || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
    e.cells = [];
    for (var k = 0; k < e.answer.length; k++) {
      var r = e.row + (e.dir === 'D' ? k : 0), c = e.col + (e.dir === 'A' ? k : 0), id = r + ',' + c;
      var cell = cells[id] || (cells[id] = { r: r, c: c, answer: e.answer[k], words: {}, value: '' });
      cell.words[e.dir] = i;
      e.cells.push(id);
      maxR = Math.max(maxR, r); maxC = Math.max(maxC, c);
    }
  });
  var rows = Math.max(maxR + 1, +app.getAttribute('data-rows') || 0), cols = Math.max(maxC + 1, +app.getAttribute('data-cols') || 0);
  // Number the squares in reading order, the way printed crosswords do.
  var n = 0;
  for (var r = 0; r < rows; r++) for (var c = 0; c < cols; c++) {
    var cl = cells[r + ',' + c]; if (!cl) continue;
    var starts = entries.filter(function (e) { return e.row === r && e.col === c; });
    if (starts.length) { n++; cl.num = n; starts.forEach(function (e) { e.num = n; }); }
  }
  var order = entries.map(function (e, i) { return i; }).sort(function (a, b) {
    var A = entries[a], B = entries[b];
    return A.dir === B.dir ? A.num - B.num : (A.dir === 'A' ? -1 : 1);
  });

  gridEl.style.setProperty('--cols', cols);
  $('.tp-mini__board').style.setProperty('--cols-n', cols);
  gridEl.style.setProperty('--rows', rows);
  for (r = 0; r < rows; r++) {
    for (c = 0; c < cols; c++) {
      var id = r + ',' + c, cell = cells[id], el = document.createElement('div');
      if (!cell) { el.className = 'tp-mini__void'; el.setAttribute('aria-hidden', 'true'); gridEl.appendChild(el); continue; }
      el.className = 'tp-mini__cell';
      el.setAttribute('role', 'gridcell');
      el.setAttribute('data-id', id);
      el.innerHTML = (cell.num ? '<span class="tp-mini__num">' + cell.num + '</span>' : '') + '<span class="tp-mini__letter"></span>';
      cell.el = el; cell.letterEl = el.querySelector('.tp-mini__letter');
      gridEl.appendChild(el);
    }
  }

  /* clue lists */
  var listItems = [];
  order.forEach(function (i) {
    var e = entries[i], li = document.createElement('li');
    li.innerHTML = '<button type="button"><b>' + e.num + '</b><span></span></button>';
    li.querySelector('span').textContent = e.clue;
    li.querySelector('button').addEventListener('click', function () { selectWord(i, true); });
    $('[data-mini-list="' + e.dir + '"]').appendChild(li);
    listItems[i] = li;
  });

  /* ---- state ---- */
  var cur = { cell: entries[order[0]].cells[0], dir: entries[order[0]].dir };
  var elapsed = 0, timerOn = false, last = 0, solved = false, revealed = false;
  var timerEl = $('[data-mini-timer]');
  var fmt = function (s) { s = Math.floor(s); return Math.floor(s / 60) + ':' + String(s % 60).padStart(2, '0'); };

  function save() {
    try {
      var v = {}; Object.keys(cells).forEach(function (k) { if (cells[k].value) v[k] = cells[k].value; });
      localStorage.setItem(KEY, JSON.stringify({ v: v, t: elapsed, s: solved, rv: revealed }));
    } catch (e) {}
  }
  function load() {
    try {
      var d = JSON.parse(localStorage.getItem(KEY) || 'null'); if (!d) return;
      Object.keys(d.v || {}).forEach(function (k) { if (cells[k]) cells[k].value = d.v[k]; });
      elapsed = d.t || 0; solved = !!d.s; revealed = !!d.rv;
    } catch (e) {}
  }

  function tick(now) {
    if (!timerOn) return;
    if (last) elapsed += (now - last) / 1000;
    last = now;
    timerEl.textContent = fmt(elapsed);
    requestAnimationFrame(tick);
  }
  var startedSent = false;
  function startTimer() {
    if (solved || timerOn) return; timerOn = true; last = 0; requestAnimationFrame(tick);
    if (!startedSent) { startedSent = true; try { if (window.Shopify && Shopify.analytics) Shopify.analytics.publish('mini_started', {}); } catch (e) {} }
  }
  function stopTimer() { timerOn = false; last = 0; save(); }
  document.addEventListener('visibilitychange', function () { if (document.hidden) stopTimer(); });

  function wordOf(id, dir) { var w = cells[id].words[dir]; return w === undefined ? cells[id].words[dir === 'A' ? 'D' : 'A'] : w; }
  function activeWord() { return wordOf(cur.cell, cur.dir); }

  function paint() {
    var wi = activeWord(), e = entries[wi];
    cur.dir = e.dir;
    Object.keys(cells).forEach(function (k) {
      var cell = cells[k];
      cell.letterEl.textContent = cell.value;
      cell.el.classList.toggle('is-word', e.cells.indexOf(k) > -1);
      cell.el.classList.toggle('is-active', k === cur.cell);
      cell.el.setAttribute('aria-label', (cell.num ? cell.num + ', ' : '') + (cell.value || 'blank'));
    });
    $('[data-mini-clue-n]').textContent = e.num + (e.dir === 'A' ? 'A' : 'D');
    $('[data-mini-clue-t]').textContent = e.clue;
    listItems.forEach(function (li, i) { if (li) li.classList.toggle('is-on', i === wi); });
    var ac = cells[cur.cell].el;
    input.style.left = ac.offsetLeft + 'px'; input.style.top = ac.offsetTop + 'px';
    input.style.width = ac.offsetWidth + 'px'; input.style.height = ac.offsetHeight + 'px';
  }

  function focusInput() { try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); } }
  function selectWord(i, focus) {
    var e = entries[i], firstEmpty = e.cells.filter(function (k) { return !cells[k].value; })[0];
    cur = { cell: firstEmpty || e.cells[0], dir: e.dir };
    paint(); if (focus) focusInput();
  }
  function stepWord(delta) {
    var pos = order.indexOf(activeWord());
    selectWord(order[(pos + delta + order.length) % order.length], false);
  }
  function move(dr, dc) {
    var p = cells[cur.cell], r2 = p.r + dr, c2 = p.c + dc;
    while (r2 >= 0 && c2 >= 0 && r2 < rows && c2 < cols) {
      if (cells[r2 + ',' + c2]) { cur.cell = r2 + ',' + c2; return true; }
      r2 += dr; c2 += dc;
    }
    return false;
  }

  function type(ch) {
    if (solved && !revealed) return;
    startTimer();
    cells[cur.cell].value = ch;
    cells[cur.cell].el.classList.remove('is-wrong');
    var e = entries[activeWord()], idx = e.cells.indexOf(cur.cell);
    // Move to the next square in this word; at the end of a word, jump to the next word that still has a gap.
    if (idx < e.cells.length - 1) cur.cell = e.cells[idx + 1];
    else if (!isFull()) {
      var p = order.indexOf(activeWord());
      for (var j = 1; j <= order.length; j++) {
        var w = entries[order[(p + j) % order.length]];
        if (w.cells.some(function (k) { return !cells[k].value; })) { selectWord(order[(p + j) % order.length]); break; }
      }
    }
    paint(); save(); checkDone();
  }
  function backspace() {
    if (solved && !revealed) return;
    var e = entries[activeWord()], idx = e.cells.indexOf(cur.cell);
    if (cells[cur.cell].value) cells[cur.cell].value = '';
    else if (idx > 0) { cur.cell = e.cells[idx - 1]; cells[cur.cell].value = ''; }
    cells[cur.cell].el.classList.remove('is-wrong');
    paint(); save();
  }
  function isFull() { return Object.keys(cells).every(function (k) { return cells[k].value; }); }

  function checkDone() {
    if (!isFull()) return;
    var right = Object.keys(cells).every(function (k) { return cells[k].value === cells[k].answer; });
    if (right) finish(false);
    else { $('[data-mini-clue-t]').textContent = 'Not quite. Something’s off. Try Check.'; }
  }

  function finish(wasRevealed) {
    solved = true; revealed = revealed || wasRevealed; stopTimer();
    app.classList.add('is-solved');
    var done = $('[data-mini-done]'); done.hidden = false;
    $('[data-mini-done-kicker]').textContent = revealed ? 'Revealed' : 'Solved';
    $('[data-mini-done-title]').textContent = revealed ? 'All the answers, filled in.' : 'Solved in ' + fmt(elapsed) + '.';
    $('[data-mini-share]').hidden = revealed;
    var ul = $('[data-mini-where]'); ul.innerHTML = '';
    order.forEach(function (i) {
      var e = entries[i]; if (!e.where) return;
      var li = document.createElement('li');
      li.innerHTML = '<b></b><a></a>';
      li.querySelector('b').textContent = e.answer;
      var a = li.querySelector('a'); a.textContent = e.where; a.href = e.href || '#';
      ul.appendChild(li);
    });
    paint(); save();
    if (!revealed) {
      try { if (window.tpCard) window.tpCard.mark('mini'); } catch (e) {}
      try { if (window.Shopify && Shopify.analytics) Shopify.analytics.publish('mini_solved', { seconds: Math.round(elapsed) }); } catch (e) {}
    }
  }

  /* ---- input ---- */
  var hadFocus = false;
  gridEl.addEventListener('pointerdown', function () { hadFocus = document.activeElement === input; });
  gridEl.addEventListener('click', function (ev) {
    var el = ev.target.closest('.tp-mini__cell'); if (!el) return;
    var id = el.getAttribute('data-id'), cell = cells[id];
    // Tapping the active square again switches direction (only once the puzzle has focus).
    if (id === cur.cell && hadFocus && cell.words.A !== undefined && cell.words.D !== undefined) cur.dir = cur.dir === 'A' ? 'D' : 'A';
    else { cur.cell = id; if (cell.words[cur.dir] === undefined) cur.dir = cur.dir === 'A' ? 'D' : 'A'; }
    paint(); focusInput();
  });
  input.addEventListener('keydown', function (ev) {
    var k = ev.key;
    if (k === 'Backspace' || k === 'Delete') { ev.preventDefault(); backspace(); return; }
    if (k === 'ArrowRight' || k === 'ArrowLeft') { ev.preventDefault(); if (cur.dir !== 'A' && cells[cur.cell].words.A !== undefined) { cur.dir = 'A'; } else move(0, k === 'ArrowRight' ? 1 : -1); paint(); return; }
    if (k === 'ArrowDown' || k === 'ArrowUp') { ev.preventDefault(); if (cur.dir !== 'D' && cells[cur.cell].words.D !== undefined) { cur.dir = 'D'; } else move(k === 'ArrowDown' ? 1 : -1, 0); paint(); return; }
    if (k === 'Tab' || k === 'Enter') { ev.preventDefault(); stepWord(ev.shiftKey ? -1 : 1); return; }
    if (k === ' ') { ev.preventDefault(); var cl = cells[cur.cell]; if (cl.words.A !== undefined && cl.words.D !== undefined) { cur.dir = cur.dir === 'A' ? 'D' : 'A'; paint(); } return; }
    if (/^[a-z0-9]$/i.test(k) && !ev.metaKey && !ev.ctrlKey && !ev.altKey) { ev.preventDefault(); type(k.toUpperCase()); }
  });
  // Phone keyboards don't always send key names; read what lands in the input instead.
  input.addEventListener('input', function (ev) {
    var v = input.value;
    if (ev.inputType === 'deleteContentBackward' || v === '') { backspace(); }
    else { var ch = v.replace(/[^a-z0-9]/gi, '').slice(-1); if (ch) type(ch.toUpperCase()); }
    input.value = '';
  });
  input.addEventListener('focus', function () {
    app.classList.add('has-focus');
    // On phones the keyboard covers half the screen: bring the clue bar and grid to the top.
    if (window.innerWidth < 760) {
      var bar = $('[data-mini-cluebar]'), top = bar.getBoundingClientRect().top + window.scrollY - 84;
      if (Math.abs(window.scrollY - top) > 40) window.scrollTo({ top: top, behavior: 'smooth' });
    }
  });
  input.addEventListener('blur', function () { app.classList.remove('has-focus'); });

  $('[data-mini-prev]').addEventListener('click', function () { stepWord(-1); focusInput(); });
  $('[data-mini-next]').addEventListener('click', function () { stepWord(1); focusInput(); });
  $('[data-mini-check]').addEventListener('click', function () {
    var wrong = 0;
    Object.keys(cells).forEach(function (k) { var c2 = cells[k]; var bad = c2.value && c2.value !== c2.answer; c2.el.classList.toggle('is-wrong', !!bad); if (bad) wrong++; });
    $('[data-mini-clue-t]').textContent = wrong ? wrong + (wrong === 1 ? ' square needs another look.' : ' squares need another look.') : 'Everything so far is right.';
  });
  $('[data-mini-reveal]').addEventListener('click', function () {
    Object.keys(cells).forEach(function (k) { cells[k].value = cells[k].answer; cells[k].el.classList.remove('is-wrong'); });
    try { if (window.Shopify && Shopify.analytics) Shopify.analytics.publish('mini_revealed', { seconds: Math.round(elapsed) }); } catch (e) {}
    finish(true);
  });
  function reset() {
    Object.keys(cells).forEach(function (k) { cells[k].value = ''; cells[k].el.classList.remove('is-wrong'); });
    elapsed = 0; solved = false; revealed = false; timerEl.textContent = '0:00';
    app.classList.remove('is-solved'); $('[data-mini-done]').hidden = true; $('[data-mini-shared]').textContent = '';
    selectWord(order[0]); save();
  }
  $('[data-mini-reset]').addEventListener('click', reset);
  $('[data-mini-again]').addEventListener('click', function () { reset(); focusInput(); });
  $('[data-mini-share]').addEventListener('click', function () {
    var text = 'I solved The Sheckii Mini in ' + fmt(elapsed) + '.';
    var url = location.origin + '/#mini';
    var out = $('[data-mini-shared]');
    if (navigator.share) { navigator.share({ title: 'The Sheckii Mini', text: text, url: url }).catch(function () {}); return; }
    var full = text + ' ' + url;
    if (navigator.clipboard) navigator.clipboard.writeText(full).then(function () { out.textContent = 'Copied: ' + full; }, function () { out.textContent = full; });
    else out.textContent = full;
  });

  load();
  timerEl.textContent = fmt(elapsed);
  paint();
  if (solved) finish(revealed);
  window.addEventListener('resize', paint);
})();
